import type { Dispatch, SetStateAction } from "react";
import { Route } from "react-router-dom";
import CalculationsPage from "./CalculationsPage";
import PageTitle from "../misc/PageTitle";
import NewCalculationPage from "./NewCalculationPage";
import EditCalculationPage from "./EditCalculationPage";
import type { CalculationFilters } from "./useCalculationsSearch";

interface Props {
  readonly calculationsSearch: CalculationFilters;
  readonly setCalculationsSearch: Dispatch<SetStateAction<CalculationFilters>>;
}

/**
 * Route tree for the legacy calculations UI. Deliberately hook-free: it is invoked as a plain function inside
 * App's render, so any hook here would register on App's fiber.
 */
export function CalculationsRoutes1({ calculationsSearch, setCalculationsSearch }: Props) {
  return (
    <Route path="calculations">
      <Route
        index
        element={
          <>
            <PageTitle title="lista kalkulacji" />
            <CalculationsPage
              search={calculationsSearch}
              onSearchChange={(change) => setCalculationsSearch((s) => ({ ...s, ...change }))}
            />
          </>
        }
      />
      <Route
        path="new"
        element={
          <>
            <PageTitle title="nowa kalkulacja" />
            <NewCalculationPage />
          </>
        }
      />
      <Route
        path=":calculationId"
        element={
          <>
            <PageTitle title="szczegóły kalkulacji" />
            <EditCalculationPage />
          </>
        }
      />
    </Route>
  );
}
